import { CookieKeys, getClientBooleanCookie } from '@finn/ui-utils';
import { useEffect, useState } from 'react';

export const useTermAvailability = () => {
  const [isTermNotAvailable, setIsTermNotAvailable] = useState(false);
  useEffect(() => {
    const handleTermNotAvailable = () => {
      setIsTermNotAvailable(
        getClientBooleanCookie(CookieKeys.CHECKOUT_TERM_NOT_AVAILABLE)
      );
    };

    handleTermNotAvailable();
  }, [setIsTermNotAvailable]);

  return isTermNotAvailable;
};
